import React from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const hdpStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (base, state) => ({
    ...base,
    minHeight: "40px",
    border: state.isFocused ? "1.5px solid #6366f1" : "1.5px solid #d1d5db",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(99,102,241,0.12)" : "none",
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: state.isDisabled ? "#f9fafb" : "#ffffff",
    "&:hover": { borderColor: state.isFocused ? "#6366f1" : "#9ca3af" },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? "#6366f1"
      : state.isFocused
      ? "#f5f3ff"
      : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#111827",
    cursor: "pointer",
  }),
  placeholder: (base) => ({ ...base, color: "#9ca3af", fontSize: "14px" }),
  singleValue: (base) => ({ ...base, fontSize: "14px", color: "#111827" }),
  input: (base) => ({ ...base, fontSize: "14px" }),
  clearIndicator: (base) => ({ ...base, cursor: "pointer" }),
  dropdownIndicator: (base) => ({ ...base, cursor: "pointer" }),
  noOptionsMessage: (base) => ({ ...base, fontSize: "13px", color: "#9ca3af" }),
};

const hdpErrorStyles = {
  ...hdpStyles,
  control: (base, state) => ({
    ...hdpStyles.control(base, state),
    border: state.isFocused ? "1.5px solid #6366f1" : "1.5px solid #ef4444",
    backgroundColor: "#fff5f5",
  }),
};

const HierarchyDropdown = ({
  options = [],
  value,
  onChange,
  placeholder = "Select…",
  isDisabled = false,
  isLoading = false,
  hasError = false,
  isCreatable = false,
}) => {
  const selected =
    options.find((o) => String(o.value) === String(value)) ||
    (value ? { label: value, value } : null);

  const SelectComponent = isCreatable ? CreatableSelect : Select;

  const creatableProps = isCreatable
    ? { formatCreateLabel: (input) => `Use "${input}"` }
    : {};

  return (
    <SelectComponent
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? String(opt.value) : "")}
      placeholder={placeholder}
      isClearable
      isSearchable
      isDisabled={isDisabled}
      isLoading={isLoading}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={hasError ? hdpErrorStyles : hdpStyles}
      noOptionsMessage={() => (isLoading ? "Loading…" : "No options found")}
      {...creatableProps}
    />
  );
};

export default HierarchyDropdown;
